<template>
  <VContainer id="technician-dashboard" fluid class="mx-0 pa-0">
    <VRow dense>
      <v-toolbar color="primary" density="comfortable">
        <v-toolbar-title class="text-white">
          {{ sessionStore.loggedUser.username }}
        </v-toolbar-title>
        <v-spacer />
        <!--
        <div class="d-flex ga-2">
          <v-tooltip location="left">
            <template #activator="{ props }">
              <v-btn icon variant="text" v-bind="props" @click="save">
                <v-icon>mdi-content-save-all</v-icon>
              </v-btn>
            </template>
            Sauvegarder
          </v-tooltip>
        </div>
      -->
      </v-toolbar>
    </VRow>
    <VRow dense>
      <VCol cols="12" md="6">
        <v-card class="card">
          <v-card-title class="d-flex align-center justify-space-between card-header"
            style="border-left: 4px solid #facd55">
            <span>Tournée du jour</span>
          </v-card-title>
          <v-divider />
          <v-card-text>
            <v-text-field v-model="taskList.codeTournee" label="Code tournée" density="compact" readonly />
            <AutoSaveSelectField v-model="taskList.taskListStatus" :items="taskListStatuses" density="compact"
              label="Status" :on-save="(val: TaskListStatus) => putTaskList({ ...taskList, taskListStatus: val })" />
          </v-card-text>
        </v-card>
      </VCol>
      <VCol cols="12" md="6">
        <v-card class="card">
          <v-card-title class="d-flex align-center justify-space-between card-header"
            style="border-left: 4px solid #ffbbff">
            <span>Véhicule</span>
          </v-card-title>
          <v-divider />
          <v-card-text>
            <AutoSaveSelectField v-model="vehicle.id" :items="vehicles" item-title="label" item-value="id"
              density="compact" label="Véhicule"
              :on-save="(val: string) => putTaskList({ ...taskList, vehicleId: val })" />
          </v-card-text>
          <v-divider />
          <!-- inventory section title -->
          <template v-if="vehicleInventoryItems.length">
            <v-card-subtitle class="inventory-title">Contenu du véhicule</v-card-subtitle>
            <v-card-text class="inventory-scroll">
              <v-list dense>
                <v-list-item v-for="(item, idx) in vehicleInventoryItems" :key="item.id"
                  :class="idx % 2 === 0 ? 'even-inv' : 'odd-inv'">
                  <v-list-item-title class="d-flex align-center justify-space-between">
                    <span>{{ item.sparepartName }}</span>
                    <v-chip small color="primary" variant="tonal" class="ml-2">
                      {{ item.quantity }}
                    </v-chip>
                  </v-list-item-title>
                  <v-list-item-subtitle v-if="item.sparepartFrenchName">
                    {{ item.sparepartFrenchName }}
                  </v-list-item-subtitle>
                </v-list-item>
              </v-list>
            </v-card-text>
            <v-divider />
          </template>
        </v-card>
      </VCol>
    </VRow>
    <VRow dense>
      <VCol cols="12" md="6">
        <v-card class="card">
          <v-card-title class="d-flex align-center justify-space-between card-header"
            style="border-left: 4px solid #aacc80">
            <span>Adresse de départ</span>
          </v-card-title>
          <v-divider />
          <v-card-text class="address-scroll">
            <v-radio-group v-model="selectedStartUserAddressId" density="compact" hide-details class="mb-3">
              <v-radio v-for="addr in userAddresses" :key="addr.id" :value="addr.id">
                <template #label>
                  <div class="address-option-row">
                    <span>{{ formatUserAddress(addr) }}</span>
                    <v-btn icon="mdi-delete-outline" size="x-small" variant="text" color="error"
                      @click.stop="removeUserAddress(addr.id)" />
                  </div>
                </template>
              </v-radio>
              <v-radio value="new" label="Nouvelle adresse" />
            </v-radio-group>
            <template v-if="selectedStartUserAddressId === 'new'">
              <v-text-field label="Ligne 1" v-model="taskList.startAddressLine1" density="compact" />
              <v-text-field label="Ligne 2" v-model="taskList.startAddressLine2" density="compact" />
              <v-text-field label="Code postal" v-model="taskList.startAddressPostalCode" density="compact" />
              <v-text-field label="Ville" v-model="taskList.startAddressCity" density="compact" />
              <v-btn color="primary" @click="putTaskList({ ...taskList })">
                Enregistrer
              </v-btn>
            </template>
          </v-card-text>
        </v-card>
      </VCol>
      <VCol cols="12" md="6">
        <v-card class="card">
          <v-card-title class="d-flex align-center justify-space-between card-header"
            style="border-left: 4px solid #ff0000">
            <span>Adresse d'arrivée</span>
          </v-card-title>
          <v-divider />
          <v-card-text class="address-scroll">
            <v-radio-group v-model="selectedEndUserAddressId" density="compact" hide-details class="mb-3">
              <v-radio v-for="addr in userAddresses" :key="addr.id" :value="addr.id">
                <template #label>
                  <div class="address-option-row">
                    <span>{{ formatUserAddress(addr) }}</span>
                    <v-btn icon="mdi-delete-outline" size="x-small" variant="text" color="error"
                      @click.stop="removeUserAddress(addr.id)" />
                  </div>
                </template>
              </v-radio>
              <v-radio value="new" label="Nouvelle adresse" />
            </v-radio-group>
            <template v-if="selectedEndUserAddressId === 'new'">
              <v-text-field label="Ligne 1" v-model="taskList.endAddressLine1" density="compact" />
              <v-text-field label="Ligne 2" v-model="taskList.endAddressLine2" density="compact" />
              <v-text-field label="Code postal" v-model="taskList.endAddressPostalCode" density="compact" />
              <v-text-field label="Ville" v-model="taskList.endAddressCity" density="compact" />
              <v-btn color="primary" @click="putTaskList({ ...taskList })">
                Enregistrer
              </v-btn>
            </template>
          </v-card-text>
        </v-card>
      </VCol>
    </VRow>
    <VRow>
      <VCol cols="12" md="6">
        <v-card class="card">
          <v-toolbar style="border-left: 4px solid #0000ff" density="compact" class="card-header laundries-header">
            <v-toolbar-title>
              Laveries à visiter
              <v-chip size="small" color="primary" variant="tonal">
                {{ tasks.length }}
              </v-chip>
            </v-toolbar-title>

            <v-spacer />

            <v-btn icon size="small" @click="optimizeRoute">
              <v-icon>mdi-map-marker-distance</v-icon>
            </v-btn>
          </v-toolbar>

          <v-divider />

          <v-card-text class="laundry-scroll">
            <draggable v-model="tasks" item-key="id" handle=".drag-handle" animation="200" ghost-class="drag-ghost"
              @end="onDragEnd">
              <template #item="{ element: task, index }">
                <v-list-item class="laundry-row" :class="[
                  index % 2 === 0 ? 'even-row' : 'odd-row',
                  task.priority === 'URGENT' && 'urgent-row',
                ]" @click="onTaskRowClick(task.id, $event)">
                  <template #prepend>
                    <!-- Drag Handle -->
                    <v-icon class="drag-handle mr-2 no-row-nav" size="18"> mdi-drag </v-icon>

                    <!-- Rank -->
                    <v-chip size="x-small" class="mr-2">
                      {{ task.rank }}
                    </v-chip>
                  </template>

                  <v-list-item-title class="d-flex align-center">
                    <span :class="{ 'text-decoration-line-through': task.taskStatus === 'FAITE' }">{{ task.name
                      }}</span>

                    <v-chip v-if="task.priority === 'urgent'" size="x-small" color="error" variant="tonal" class="ml-2">
                      Urgent
                    </v-chip>
                  </v-list-item-title>

                  <v-list-item-subtitle>
                    <p>{{ task.number }} {{ task.street }}</p>
                    <p>{{ task.postcode }} {{ task.city }}</p>
                  </v-list-item-subtitle>

                  <template #append>
                    <v-btn class="no-row-nav" icon size="x-small" @click.stop.prevent="moveUp(index)">
                      <v-icon size="16">mdi-chevron-up</v-icon>
                    </v-btn>

                    <v-btn class="no-row-nav" icon size="x-small" @click.stop.prevent="moveDown(index)">
                      <v-icon size="16">mdi-chevron-down</v-icon>
                    </v-btn>
                  </template>
                </v-list-item>
              </template>
            </draggable>
          </v-card-text>
        </v-card>
      </VCol>

      <VCol cols="12" md="6">
        <v-card class="card directions-card">
          <v-card-title class="d-flex align-center justify-space-between card-header"
            style="border-left: 4px solid #1565c0">
            <span>Directions</span>
          </v-card-title>
          <v-divider />
          <v-card-text class="pa-0 flex-grow-1">
            <RouteMapComponent v-if="taskList.id && debouncedStartAddress && debouncedEndAddress"
              :start-address="debouncedStartAddress" :end-address="debouncedEndAddress" :tasks="tasks"
              :task-list-direction="taskListDirection" :task-list-direction-loading="taskListDirectionLoading" />
            <div v-else class="map-placeholder">
              <v-icon size="48" color="grey-lighten-1">mdi-map-outline</v-icon>
              <p class="text-medium-emphasis mt-2">Aucune tournée chargée</p>
            </div>
          </v-card-text>
        </v-card>
      </VCol>
    </VRow>
  </VContainer>
</template>

<script setup lang="ts">
import RouteMapComponent from "@/components/RouteMapComponent.vue";
import { useAppStore, useSessionStore } from "@/store";
import { GeoAddress, Task, TaskList, TaskListStatus, UserAddress, Vehicle, VehicleInventoryItem } from "@/types";
import type { TaskListDirection } from "@/types/task-list-direction";
import { getTasksByTaskListId, updateTaskRank } from "@/utils/task-api";
import { fetchTaskListDirection, getFilteredTaskLists, postOptimizeRoute, putTaskList } from "@/utils/tasklist-api";
import { getAllVehicles, getVehicleByTaskListId, getVehicleInventoryItems } from "@/utils/vehicle-api";
import { assignVehicleToTaskList } from "@/utils/tasklist-api";
import { fetchGeoAddress } from "@/utils/geo-address-api";
import { deleteUserAddress, fetchAllUserAddresses } from "@/utils/user-address-api";
import { onBeforeUnmount, onMounted, ref, watch } from "vue";
import { useRouter } from "vue-router";
import draggable from "vuedraggable";
import AutoSaveSelectField from "@/components/AutoSaveSelectField.vue";

const appStore = useAppStore();
const sessionStore = useSessionStore();
const router = useRouter();

const createEmptyTaskList = (): TaskList => ({
  codeTournee: "",
  startDate: new Date(),
  endDate: new Date(),
  technicianIds: [],
  technicianNames: [],
  taskListStatus: TaskListStatus.A_FAIRE,
  label: "",
});

const createEmptyVehicle = (): Vehicle => ({
  id: "",
  label: "",
  plateNumber: "",
});

const taskListStatuses = [TaskListStatus.EN_COURS, TaskListStatus.FAITE];
const taskList = ref<TaskList>(createEmptyTaskList());
const tasks = ref<Task[]>([]);
const vehicles = ref<Vehicle[]>([]);
const vehicle = ref<Vehicle>(createEmptyVehicle());
const vehicleInventoryItems = ref<VehicleInventoryItem[]>([]);
const loading = ref(false);
const userAddresses = ref<UserAddress[]>([]);
const selectedStartUserAddressId = ref<string>('new');
const selectedEndUserAddressId = ref<string>('new');
const debouncedStartAddress = ref<GeoAddress | null>(null);
const debouncedEndAddress = ref<GeoAddress | null>(null);
const taskListDirection = ref<TaskListDirection | null>(null);
const taskListDirectionLoading = ref(false);

let mapAddressDebounceTimeout: ReturnType<typeof setTimeout> | null = null;

async function queueDirectionsAddressUpdate() {
  if (mapAddressDebounceTimeout) {
    clearTimeout(mapAddressDebounceTimeout);
  }

  mapAddressDebounceTimeout = setTimeout(async () => {
    if (taskList.value.startGeoAddressId) {
      try {
        debouncedStartAddress.value = await fetchGeoAddress(taskList.value.startGeoAddressId);
      } catch (e) {
        // Ignore error
      }
    }
    if (taskList.value.endGeoAddressId) {
      try {
        debouncedEndAddress.value = await fetchGeoAddress(taskList.value.endGeoAddressId);
      } catch (e) {
        // Ignore error
      }
    }
  }, 2000);
}

async function refreshTaskListDirection() {
  if (!taskList.value.id) {
    taskListDirection.value = null;
    return;
  }

  try {
    taskListDirectionLoading.value = true;
    taskListDirection.value = await fetchTaskListDirection(taskList.value.id);
  } catch (e) {
    taskListDirection.value = null;
  } finally {
    taskListDirectionLoading.value = false;
  }
}

watch(
  () => ({ startId: taskList.value.startGeoAddressId, endId: taskList.value.endGeoAddressId }),
  () => queueDirectionsAddressUpdate(),
  { deep: true, immediate: true }
);

watch(selectedStartUserAddressId, async (id) => {
  if (id === 'new') {
    taskList.value.startGeoAddressId = undefined;
    taskList.value.startNewUserAddress = true;
    return;
  }

  const previousStartGeoAddressId = taskList.value.startGeoAddressId;
  taskList.value.startAddressLine1 = '';
  taskList.value.startAddressLine2 = '';
  taskList.value.startAddressPostalCode = '';
  taskList.value.startAddressCity = '';
  taskList.value.startNewUserAddress = false;

  const addr = userAddresses.value.find(a => a.id === id);
  taskList.value.startGeoAddressId = addr?.geoAddressId;

  if (taskList.value.id && previousStartGeoAddressId !== taskList.value.startGeoAddressId) {
    try {
      await putTaskList(taskList.value);
    } catch (e) {
      // Ignore because it's handled in axios service
    }
  }
});

watch(selectedEndUserAddressId, async (id) => {
  if (id === 'new') {
    taskList.value.endGeoAddressId = undefined;
    taskList.value.endNewUserAddress = true;
    return;
  }

  const previousEndGeoAddressId = taskList.value.endGeoAddressId;
  taskList.value.endAddressLine1 = '';
  taskList.value.endAddressLine2 = '';
  taskList.value.endAddressPostalCode = '';
  taskList.value.endAddressCity = '';
  taskList.value.endNewUserAddress = false;

  const addr = userAddresses.value.find(a => a.id === id);
  taskList.value.endGeoAddressId = addr?.geoAddressId;

  if (taskList.value.id && previousEndGeoAddressId !== taskList.value.endGeoAddressId) {
    try {
      await putTaskList(taskList.value);
    } catch (e) {
      // Ignore because it's handled in axios service
    }
  }
});

onBeforeUnmount(() => {
  if (mapAddressDebounceTimeout) {
    clearTimeout(mapAddressDebounceTimeout);
    mapAddressDebounceTimeout = null;
  }
});

function formatUserAddress(addr: UserAddress): string {
  const parts = [addr.line1, addr.line2, addr.postalCode, addr.city].filter(Boolean);
  return parts.join(', ');
}

async function removeUserAddress(userAddressId?: string) {
  if (!userAddressId) {
    return;
  }

  try {
    await deleteUserAddress(userAddressId);

    const userId = sessionStore.loggedUser.id;
    if (!userId) {
      return;
    }

    userAddresses.value = await fetchAllUserAddresses(userId);

    const hasStartSelection = userAddresses.value.some((a) => a.id === selectedStartUserAddressId.value);
    if (!hasStartSelection && selectedStartUserAddressId.value !== 'new') {
      selectedStartUserAddressId.value = userAddresses.value.find((a) => a.isDefault)?.id ?? 'new';
    }

    const hasEndSelection = userAddresses.value.some((a) => a.id === selectedEndUserAddressId.value);
    if (!hasEndSelection && selectedEndUserAddressId.value !== 'new') {
      selectedEndUserAddressId.value = userAddresses.value.find((a) => a.isDefault)?.id ?? 'new';
    }

    appStore.sendSuccessNotice("Adresse supprimée.");
  } catch (e) {
    // Ignore because it's handled in axios service
  }
}

async function save() {
  try {
    loading.value = true;
    await putTaskList(taskList.value);
    appStore.sendSuccessNotice("TaskList has been updated.");
  } catch (e) {
    // Ignore because it's handled in axios service
  } finally {
    loading.value = false;
  }
}

async function optimizeRoute() {
  if (!taskList.value.startGeoAddressId) {
    appStore.sendErrorNotice("L'adresse de départ est requise pour optimiser la route");
    return;
  }
  if (!taskList.value.endGeoAddressId) {
    appStore.sendErrorNotice("L'adresse d'arrivée est requise pour optimiser la route");
    return;
  }

  try {
    loading.value = true;
    await postOptimizeRoute(taskList.value.id);
    tasks.value = await getTasksByTaskListId(taskList.value.id);
    await refreshTaskListDirection();
  } catch (e) {
    // Ignore because it's handled in axios service
  } finally {
    loading.value = false;
  }
}

async function onDragEnd() {
  // Recalculate ranks
  tasks.value.forEach((l, i) => {
    l.rank = i + 1;
  });

  await saveRanks();
}

async function saveRanks() {
  try {
    await Promise.all(tasks.value.map((task) => updateTaskRank(task)));
    await refreshTaskListDirection();
  } catch (e) {
    // Ignore because it's handled in axios service
  }
}


function moveUp(index: number) {
  if (index === 0) return;
  tasks.value.splice(index - 1, 0, tasks.value.splice(index, 1)[0]);
  onDragEnd();
}

function moveDown(index: number) {
  if (index === tasks.value.length - 1) return;
  tasks.value.splice(index + 1, 0, tasks.value.splice(index, 1)[0]);
  onDragEnd();
}

function onTaskRowClick(taskId: string, event: MouseEvent) {
  const target = event.target as HTMLElement | null;
  if (target?.closest('.no-row-nav')) {
    return;
  }

  router.push(`/on-going-interventions/${taskId}`);
}

onMounted(async () => {
  try {
    const userId = sessionStore.loggedUser.id;
    if (!userId) {
      return;
    }

    userAddresses.value = await fetchAllUserAddresses(userId);

    const taskLists = await getFilteredTaskLists(
      Array.of(TaskListStatus.ASSIGNE, TaskListStatus.EN_COURS, TaskListStatus.FAITE),
      userId,
      new Date()
    );
    if (taskLists.length === 0) {
      appStore.sendInfoNotice("Aucune tournée assignée pour aujourd'hui");
      return;
    }

    if (taskLists.length > 1) {
      appStore.sendErrorNotice("Plusieurs tournées assignées pour aujourd'hui");
      return;
    }

    taskList.value = taskLists[0];

    // Pre-select saved address if taskList already has one
    const matchStart = userAddresses.value.find(a => a.geoAddressId === taskList.value.startGeoAddressId);
    if (matchStart?.id) {
      selectedStartUserAddressId.value = matchStart.id;
      taskList.value.startNewUserAddress = false;
    } else {
      const defaultStart = userAddresses.value.find(a => a.isDefault);
      if (defaultStart?.id) {
        selectedStartUserAddressId.value = defaultStart.id;
        taskList.value.startNewUserAddress = false;
      } else {
        selectedStartUserAddressId.value = 'new';
        taskList.value.startNewUserAddress = true;
      }
    }

    const matchEnd = userAddresses.value.find(a => a.geoAddressId === taskList.value.endGeoAddressId);
    if (matchEnd?.id) {
      selectedEndUserAddressId.value = matchEnd.id;
      taskList.value.endNewUserAddress = false;
    } else {
      const defaultEnd = userAddresses.value.find(a => a.isDefault);
      if (defaultEnd?.id) {
        selectedEndUserAddressId.value = defaultEnd.id;
        taskList.value.endNewUserAddress = false;
      } else {
        selectedEndUserAddressId.value = 'new';
        taskList.value.endNewUserAddress = true;
      }
    }

    const [allTasks, allVehicles] = await Promise.all([
      getTasksByTaskListId(taskList.value.id),
      getAllVehicles(),
    ]);
    tasks.value = allTasks;
    vehicles.value = allVehicles;
    await refreshTaskListDirection();

    vehicle.value = await getVehicleByTaskListId(taskList.value.id);
    if (vehicle.value.id) {
      vehicleInventoryItems.value = await getVehicleInventoryItems(vehicle.value.id);
    }

    // watch for vehicle selection changes and reload inventory
    watch(
      () => vehicle.value.id,
      async (id) => {
        if (id) {
          vehicleInventoryItems.value = await getVehicleInventoryItems(id);
          if (taskList.value.id) {
            try {
              await assignVehicleToTaskList(taskList.value.id, id);
            } catch (e) {
              // Ignore because it's handled in axios service
            }
          }
        } else {
          vehicleInventoryItems.value = [];
        }
      }
    );
  } catch (error) {
    // Ignore
  }
});
</script>

<style scoped>
.card {
  height: 320px;
  display: flex;
  flex-direction: column;
}

.card-header {
  padding-left: 12px;
}

.address-scroll {
  max-height: clamp(180px, 34vh, 360px);
  overflow-y: auto;
}

.address-option-row {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

@media (max-width: 1264px) {
  .address-scroll {
    max-height: clamp(220px, 42vh, 460px);
  }
}

@media (max-width: 960px) {
  .address-scroll {
    max-height: none;
  }
}

.laundry-scroll {
  max-height: 320px;
  overflow-y: auto;
}

.laundry-row {
  padding: 10px 8px;
}

.drag-handle {
  cursor: grab;
  opacity: 0.6;
}

.drag-ghost {
  opacity: 0.4;
}

.even-row {
  background: rgba(0, 0, 0, 0.02);
}

.odd-row {
  background: rgba(0, 0, 0, 0.08);
}

.urgent-row {
  border-left: 4px solid rgb(var(--v-theme-error));
}

.inventory-scroll {
  max-height: 160px;
  overflow-y: auto;
}

.inventory-title {
  font-weight: bold;
  padding-left: 16px;
  padding-top: 8px;
}

.even-inv {
  background-color: #f0f8ff;
}

.odd-inv {
  background-color: #e0f0ff;
}

.laundries-header {
  background-color: #e3f2fd !important;
}

.directions-card {
  height: 320px;
  display: flex;
  flex-direction: column;
}

.directions-card .v-card-text {
  overflow: hidden;
  height: 100%;
}

.map-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  min-height: 240px;
}
</style>
